import React from 'react';
import { Ship, Lock, DollarSign, MapPin, ArrowRight, CheckCircle, Truck, Shield, Anchor } from 'lucide-react';
import SEO from '../components/SEO';

const BoatRVParking = () => {
    const features = [
        {
            icon: <Truck className="h-8 w-8 text-blue-600" />,
            title: 'Wide Turning Radius',
            description: 'Easy pull-through access for big rigs and large trailers.'
        },
        {
            icon: <Shield className="h-8 w-8 text-blue-600" />,
            title: '24/7 Gated Access',
            description: 'Secure electronic gate entry for peace of mind.'
        },
        {
            icon: <Anchor className="h-8 w-8 text-blue-600" />,
            title: 'Close to Local Lakes',
            description: 'Convenient location for quick weekend getaways.'
        },
        {
            icon: <CheckCircle className="h-8 w-8 text-blue-600" />,
            title: 'Affordable Rates',
            description: 'Best value "Park & Go" storage in Bells.'
        }
    ];

    return (
        <div className="min-h-screen bg-gray-50">
            <SEO
                title="Boat & RV Parking | VD Storage Bells, TX"
                description="Covered and uncovered boat & RV parking in Bells, TX. Easy Hwy 82 access, 24/7 entry, competitive monthly rates."
                canonical="/boat-rv-parking-bells"
            />
            {/* Hero Section */}
            <section className="bg-green-600 text-white py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">
                        Boat & RV Parking in Bells, TX
                    </h1>
                    <p className="text-xl text-green-100 max-w-3xl mx-auto mb-8">
                        Secure, affordable outdoor storage for recreational vehicles. Avoid city prices and park with ease.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="https://vdstoragebells.mysms360.com/rent?utm_source=vdstoragebells.com&utm_content=boatrv"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                if (window.gtag) {
                                    window.gtag('event', 'conversion_intent', {
                                        'event_category': 'lead',
                                        'event_label': 'boatrv_hero_rates',
                                        'facility_name': 'VD Storage Bells'
                                    });
                                }
                            }}
                            className="inline-flex items-center px-8 py-3 text-lg font-semibold text-green-600 bg-white rounded-lg hover:bg-gray-100 transition-colors shadow-lg"
                        >
                            See Parking Rates
                            <ArrowRight className="ml-2 h-5 w-5" />
                        </a>
                    </div>
                </div>
            </section>

            {/* Features Grid */}
            <section className="py-16 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">Designed for Recreational Vehicle Owners</h2>
                        <p className="text-lg text-gray-600">Why tow it home when you can park it here?</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {features.map((feature, index) => (
                            <div key={index} className="bg-gray-50 p-6 rounded-xl text-center shadow-sm hover:shadow-md transition-shadow">
                                <div className="inline-block p-3 bg-blue-100 rounded-full mb-4">
                                    {feature.icon}
                                </div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                                <p className="text-gray-600">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="py-16 bg-gray-100">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl font-bold text-gray-900 mb-6">Ready to Park?</h2>
                    <p className="text-xl text-gray-600 mb-8">
                        Reserve your spot online in minutes. No admin fees, month-to-month leases.
                    </p>
                    <a
                        href="https://vdstoragebells.mysms360.com/rent?utm_source=vdstoragebells.com&utm_content=boatrv"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            if (window.gtag) {
                                window.gtag('event', 'conversion_intent', {
                                    'event_category': 'lead',
                                    'event_label': 'boatrv_cta_reserve',
                                    'facility_name': 'VD Storage Bells'
                                });
                            }
                        }}
                        className="inline-flex items-center px-8 py-4 text-lg font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                    >
                        Reserve Now
                        <ArrowRight className="ml-2 h-5 w-5" />
                    </a>
                </div>
            </section>
        </div>
    );
};

export default BoatRVParking;
